export type PersonLocationType = 'primary' | 'secondary' | 'home_office';

export interface PersonLocationAssignment {
  id: string;
  personId: string;
  locationId: string;
  type: PersonLocationType;
  startDate?: string | null;
  endDate?: string | null;
  locationName: string;
  locationType: string;
}
